import { Sounds } from '../../sounds';
import { TutorialSteps } from '../../prefabs/game/Tutorial';
import {Level, LevelMapName, LevelName} from './level';

export const Level1: Level = {
  id:LevelName.Level1,
  //smash levels are how many crates need to be smashed to reach X star goals
  smashLevels:{
    smashLevels: [40,60,80]
  },
  //target score is how many crates need to be smashed to unlock the next level
  targetScore:40,
  levelMap:LevelMapName.Level1,
  levelBackground:"bg-desert.jpg",
  gameplayBackground:"gameplay-desert.png",
  levelBackgroundAtlas:"game-desert",
  friction:0.99,
  lives: 3,
  bumperDownKey:"bumper-down-desert.png",
  tutorialStep:[TutorialSteps.MovePlayer,TutorialSteps.PressBumper,TutorialSteps.PressPowerup,TutorialSteps.MovePlayerInMotion],
  arrowColor:0x793223,
  bgMusic:Sounds.Track.DesertMusicLoop
}
